const styles = {
	desktopContainer(mobileOnly) {
		let display = { zero: "none", sm1: "flex" }
		if (mobileOnly) display = "none"

		return {
			width: "100%",
			display,
			justifyContent: "center",
			alignItems: "center"
		}
	},

	mobileContainer(mobileOnly) {
		let display = { zero: "flex", sm1: "none" }
		if (mobileOnly) display = null

		return {
			boxSizing: "border-box",
			marginTop: "50px",
			width: "100%",
			display,
			justifyContent: "center",
			alignItems: "center",

			"*": {
				boxSizing: "border-box"
			}
		}
	}
}

export default styles
